import React, {useCallback, useRef, useState} from "react";
import "./planScreen.css";
import PlanMap, {PlanMapRef} from "../map/PlanMap";
import {PlanControlButtons} from "../controls/PlanControlButtons";
import {PlanFilter} from "../filter/PlanFilter";
import {getTrackingList} from "shared/lib/fns";
import {SectorTable} from "../filter/SectorTable";
import {PlanTable, PlanTableRef} from "../filter/PlanTable";
import {SelectedShippings} from "shared/ui/selectedShippings/SelectedShippings";
import {Breadcrumb} from "shared/ui";
import {useTranslation} from "react-i18next";
import {IPlanLongItem, IShippingWithCluster} from "features/plan/types";

const PlanMapScreen = () => {
  const tableRef = useRef<PlanTableRef | null>(null);
  const mapRef = useRef<PlanMapRef | null>(null);
  const [selectedPlans, setSelectedPlans] = useState<IPlanLongItem[]>([]);
  const [selectedTrackings, setSelectedTrackings] = useState<string[]>([]);
  const {t} = useTranslation(["common"]);
  
  const handleRefresh = useCallback(() => {
    if (tableRef.current) {
      tableRef.current.refresh();
    }
  }, []);
  
  const handleSelectShippings = useCallback((shippings: IShippingWithCluster[]) => {
    setSelectedTrackings(getTrackingList(shippings, "shipping_item__tracking_number"))
  }, []);
  
  const handleResetMapShippings = useCallback(() => {
    if (mapRef.current) {
      mapRef.current.resetSelectedShippings();
    }
  }, []);
  
  const handleSelectPlans = useCallback((plans: IPlanLongItem[]) => {
    setSelectedPlans(plans);
    handleResetMapShippings();
  }, []);
  
  const handleUpdated = useCallback((type: "shift" | "merge" | "create") => {
    if (tableRef.current) {
      tableRef.current.refresh();
    }
    if (type !== "shift") setSelectedTrackings([]);
  }, []);
  
  const header = (<div className={"breadcrumb"}>
    <Breadcrumb parentLabel={t("box")} childLabel={t("box.plan")} />
    <div className={"ml-auto flex items-center gap-2"}>
      <PlanFilter />
      <PlanControlButtons
        selectedTrackings={selectedTrackings}
        selectedPlans={selectedPlans}
        onUpdated={handleUpdated}
      />
    </div>
  </div>);
  
  const filter = (<div className={"plan-filter"}>
    <div className={"upper"}>
      <SectorTable />
      <PlanTable
        ref={tableRef}
        onSelectData={handleSelectPlans}
      />
    </div>
    <div className={"lower"}>
      <SelectedShippings
        trackingList={selectedTrackings}
        onReset={handleResetMapShippings} />
    </div>
  </div>);
  
  return (<div className={"plan h-full flex flex-col p-4 gap-[10px] min-h-0 flex-1"}>
    {header}
    <div className={"h-full min-h-0 flex gap-3"}>
      {filter}
      <PlanMap
        ref={mapRef}
        selectedPlans={selectedPlans}
        onSelectShippings={handleSelectShippings}
        onRefresh={handleRefresh}
      />
    </div>
  </div>);
};

export default PlanMapScreen;
